baseIsDate